import React, { Component } from 'react';
import '../../assets/css/common.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'
import './index.css'
import buildImg from '../../assets/img/building.png'

class AboutUs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			aboutus: '',
			contactus: '',
		};
	}


	componentDidMount() {
		
	}

	render() {
		return (
			<div style={{ margin: '40px 15%', }}>
				<MyBreadcrumb urls={[
					{ url: '/building', breadcrumbName: '建设中' },
				]} />
				{/* 关于我们 */}
				<div className="picContainer">
					<img alt="" src={buildImg}/>
					
				</div>
				<div className="major-heading module-title picContainer" style={{ textAlign: 'left', marginTop: 10, color: '#144db9' }}>正在建设中...</div>
			</div>
		);
	}
}

export default AboutUs
